<!--区域作物窗口-->
<template>
  <div class="center_map_box"  v-loading="loading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.3)">
    <!--头部-->
    <div class="window_header">
      <div style="width: 100%;height: 100%;background-color: transparent;" >
        <!-- <span style="position: relative;top: 5px;font-size: 17px;color: #fff;" >当前区域：{{areaName}}</span> -->
        <div class="onemap_link">
          <span @click="restore" style="cursor: pointer;">
            <i class="el-icon-refresh-right"></i>
            重置
          </span>
          <!-- &nbsp; -->
          <!-- <span @click="skipToOnemap" style="cursor: pointer;">
            <i class="el-icon-data-analysis"></i>
            <span>主体一张图</span>
          </span> -->
        </div>
      </div>

    </div>
    <!--内容-->
    <div class="window_content"  >
      <div style="width: 100%;height: 100%;" ref = "big_scr_map_box" ></div>
    </div>
  </div>
</template>

<script>
  import busAPI from '../../../api/bigScreen/api_big_screen';
  import Cookies from "js-cookie"
  export default {
    name: "area_work",
    created(){
      this.GLOBAL.eventBus.$on("big_screen_resize",this.winResize)
      this.GLOBAL.eventBus.$on("subsidyChange", this.getMap);
    },
    mounted(){
      this.init();
    },
    computed: {
      mapOption() {
        return {
          backgroundColor:'transparent',
          tooltip: {
            trigger: 'item'
          },
          //地图基础坐标系
          geo: {
            map: this.areaCode,
            // show:true,
            zoom: 1.2,
            roam: true,
            //坐标系底色
            label: {
              normal: {
                show: !0,
                textStyle: {
                  color: '#fff'
                }
              },
            },

            /*区域样式*/
            itemStyle: {
              areaColor: '#00103F',/*区域颜色*/
              borderColor: '#00E8EC',/*区域边框颜色*/
              borderWidth: 1,/*区域边框宽度*/
            },

            /*hover区域样式，内容同区域样式*/
            emphasis:{
              itemStyle: {
                areaColor: '#2C88EE',
              },
            },
            aspectScale: 0.8,
            scaleLimit: {
              min: 1,
              max: 3
            },
          },
          visualMap: [{
            show: true,
            seriesIndex: [0],//必须,地图视觉样式
            min: 0,
            max:this.max_service_area,
            calculable: true,
            inRange: {
              color: ['#196FD7','#163069'],
            },
            formatter: function (value) {
              let res = parseFloat(value.toFixed(2))  + "家" ;
              if(value >= 10000 && value <= 10000000){res =  parseFloat((value/10000).toFixed(2)) + "万家";}
              if(value > 10000000){res =  parseFloat((value/100000000).toFixed(2)) + "亿家";}
              return res
            },
            text: [''],
            textStyle: {
              color: '#fff'
            },
          }],
          series: [
            //业务区域投保数据序列
            {
              map: this.areaCode,//注册的map名
              type: 'map',
              zoom:1.2,
              roam: true,
              geoIndex: 0,
              tooltip: {
                trigger: 'item',
                backgroundColor: 'rgba(255,255,255,0.15)',
                borderColor: '#00D7FE',
                textStyle: {
                  color: 'white',
                  fontSize: 14,
                  fontWeight: 'normal'
                },
                formatter:(params)=> {
                  /*单位转换函数*/
                  let unithFunc = function(val = 0,unit){
                    let res = "";
                    if(val > 10000){
                      res = parseFloat((val/10000).toFixed(2)) + "万" + unit
                    }else{
                      res = parseFloat(val.toFixed(2)) + unit
                    }
                    return res
                  }
                  params.data.serviceRatio = params.data.serviceRatio || 0;
                  return '<span style="color: #f9d543" >'+ params.name +'：</span>' +'<br/>'+
                    '合作社：'+ unithFunc(params.data.hzsCount,'家')+'<br/>' +
                    '种植大户：'+ unithFunc(params.data.zydhCount,'家')+'<br/>' +
                    '龙头企业：'+ unithFunc(params.data.ltqyCount,'家')+'<br/>' +
                    '家庭农场：'+ unithFunc(params.data.jtncCount,'家')+'<br/>'
                    // '托管面积：'+ unithFunc(params.data.tgmj,'亩')+'<br/>'+
                    // '作业面积：'+ unithFunc(params.data.serviceArea,'亩.次')+'<br/>'+
                    // '农机具：'+ unithFunc((params.data.machineCount || 0 )+  (params.data.toolsCount || 0),"台/套" )+'<br/>'+
                    // '服务小农户：'+ unithFunc(params.data.nhCount ,'户')  +'<br/>'+
                    // '小农户占比：'+  "100%" +'<br/>' + //parseFloat(params.data.serviceRatio.toFixed(2)) + "%" +'<br/>' +
                    // '合同金额：'+ unithFunc(params.data.tgje,"元") + '<br/>'
                }
              },
              data:this.statsData,
              z:2
            }
          ]
        }
      },
    },
    data(){
      return{
        loading:false,
        mapShape:{},
        mapView:"",
        areaCode:Cookies.get('areacode'),
       // areaCode:'21',
        areaName: Cookies.get('areaname'),
        statsData: [],
        max_service_area:"",/*最大服务面积*/
      }
    },
    methods:{
      skipToOnemap(){
        this.$router.push('/oneMap');
      },
      /*重置下钻*/
      restore(){
        if(this.areaCode == Cookies.get('areacode')){return}
        this.areaCode = Cookies.get('areacode')
        this.areaName = Cookies.get('areaname')
        this.GLOBAL.eventBus.$emit("refresh_big_screen_info",this.areaCode);
      /*  this.areaCode = "21"
        this.areaName = "辽宁"*/
        this.getMap(this.areaCode);
      },

      init(){
        this.getMap(Cookies.get("areacode"));
        //this.getMap("21");
      },

      async getMap(areaCode){
        try{
          if(this.mapShape[areaCode]){this.beforeUpdataMap(areaCode);return}
          this.loading = true;
          let map_geometry = await busAPI.getSubPosition_simple({qhdm:areaCode});
          let busData = [];
          var centerpoint;
          /*返回的数据里面是json串，处理后再使用*/
          map_geometry.data.features.forEach((item) => {
            busData.push({name:item.properties.qhmc,qhdm:item.properties.qhdm})
            item.coid = JSON.parse(item.coid)//储存区划中心坐标
            centerpoint=new Array();
            centerpoint[0]=item.coid.coordinates[0]
            centerpoint[1]=item.coid.coordinates[1]
            item.properties.cp=centerpoint //设置文字出现的中心点
            item.properties.value = item.properties.qhdm
            item.geometry = JSON.parse(item.geometry)
            item.properties.name = item.properties.qhmc
          })
          this.mapShape[areaCode] = {shape: map_geometry.data,busData:busData}// 保存地图数据为缓存，后续不再请求
          this.beforeUpdataMap(areaCode)
        }catch (err){
          this.GLOBAL.warning("获取地图数据错误")
        }
      },

      /*更新地图之前*/
      beforeUpdataMap(areaCode){
        /*清除上一实例*/
        if(this.mapView){this.mapView.dispose();this.mapView = ""};
        /*如果未注册则注册*/
        if(!this.$echarts.getMap(areaCode)){
          if(!this.mapShape[areaCode]){console.log("无该行政区地图数据");return}
          this.$echarts.registerMap(areaCode, this.mapShape[areaCode].shape)
        }
        this.mapView = this.$echarts.init(this.$refs.big_scr_map_box);/*实例化*/
        this.updateMap(areaCode);
      },

      //更新地图
     async updateMap(areaCode) {
        //debugger
        try{
          this.loading = true;
          this.bindEvent()
          /*请求业务数据*/
          let business_data = await busAPI.get_big_screen_middle_down_info({qhdm:areaCode});
          if(business_data.code == 0){
            let map_bus_data = this.mapShape[areaCode].busData;/*找到对应区划的地图业务数据*/
            /*将数据业务数据与地图业务数据对号入座，也就是将数据业务数据融合进地图业务数据*/
            let maxNum = 10;/*最大数量*/
            business_data.data.list.forEach(item => {
              item.sum = item.jtncCount + item.hzsCount + item.ltqyCount + item.zydhCount;
              // item.sumCount  = item.ltqyCount + item.zydhCount;
              if(item.sum > maxNum){maxNum = item.sum};/*计算合作社+家庭农场最大数量*/
              //  if(item.sumCount > maxNum){maxNum = item.sumCount};/*计算合作社+家庭农场最大数量*/
              /*给地图数据赋业务值,为0不给赋值，效果为透明*/
              if(item.sum){
                item.value = item.sum
              }else if(item.sum==0){
                item.value = null
              }
              //  if(item.sumCount){
              //   item.value = item.sumCount
              // }else if(item.sumCount==0){
              //   item.value = null
              // }
              /*将查询的业务数据赋值给地图的业务数据*/
              let map_bus_data_item =  {}
              //let map_bus_data.find(itemInner => {return itemInner.qhdm == item.qhdm}); // find不满足条件时返回undefined，函数直接抛出到catch
              for(let itemInner in map_bus_data){
                if(itemInner.qhdm === item.qhdm){
                  map_bus_data_item = itemInner.qhdm;
                  break;
                }
              }
              var integSign = Object.assign(map_bus_data_item,item);
              map_bus_data.forEach(item1 => {
                if(item1.qhdm == integSign.qhdm){
                  Object.assign(item1,Object.assign(map_bus_data_item,item))
                }
              })
            })
            this.max_service_area = maxNum;
            this.statsData = map_bus_data;//更新echarts业务数据
            this.mapView.setOption(this.mapOption);
            this.mapView.resize();
            this.mapView.on("rendered",this.rendered)
            window.addEventListener("resize", this.mapView.resize);
          }else{
            this.GLOBAL.warning( business_data.msg || "获取区域作业业务数据错误");
          }
        }catch (err){
          this.GLOBAL.warning("获取区域作业业务数据失败");
        }
      },

      /*地图渲染完成之后*/
      rendered(){
        this.loading = false;
        this.mapView.off("rendered",this.rendered)
      },


      bindEvent(){
        this.mapView.on('restore', this.restore);
        this.mapView.on('click', this.drillDown);
      },

      drillDown(params){
        if(!params.data){return}
        if(params.data.qhdm.length > 6){return}
        this.areaCode = params.data.qhdm
        this.areaName = params.data.name;
        this.getMap(params.data.qhdm);
        this.GLOBAL.eventBus.$emit("refresh_big_screen_info",params.data.qhdm);
      },

      winResize(){
        if(this.mapView){this.mapView.resize();}
      },

    },
    beforeDestroy(){
      this.GLOBAL.eventBus.$off("big_screen_resize",this.winResize)
      this.GLOBAL.eventBus.$off("subsidyChange", this.getMap);
    }
  }
</script>

<style lang="less">
.center_map_box{
  position: relative;
  width: 100%;
  .window_header{
    height: 30px;
    width: 100%;
    position: relative;
    // padding-left: 20px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    // font-weight: bold;
    color: #333333;
    line-height: 30px;
    .onemap_link{
      position: absolute;
      right: 32px;
      top: 8px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      i{
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
  height: 100%;
  .window_content{
    width: 100%;
    height: calc(100% - 60px);
  }
}
  .map_set_btn{
    &:hover{
      cursor: pointer;
      color: #00D0FF;
    }
  }

</style>
v



// WEBPACK FOOTER //
// src/studio/homepage/home/homecentremiddle.vue